module.exports = __webpack_public_path__ + "cd6090c2e8a14bcc653067d0467a4124.svg";